// lib/entitlements.js — client tier layer for WTR+ (Commit 5).
//
// Single source of client-side tier truth, fed by the server:
//   GET /api/wtr/me/entitlements  ->  { ok, tier: 'plus'|'free', grants }
//
// Rules of this module:
//   - Display truth ONLY. The server enforces every paid endpoint with a 403
//     (WTR_PLUS_REQUIRED); this module just decides which nav to draw. A
//     tampered client gets a prettier wall, never the data.
//   - Fail closed. No session, fetch error, or malformed response all resolve
//     to 'free'.
//   - One event: 'wtr-tier-changed' fires on every refresh so the shell can
//     re-render nav without prop drilling.
//
// Usage (TrustButVerify.js):
//   import { currentTier, refreshTier } from './lib/entitlements';
//   refreshTier() on boot, after magic-link sign-in, and on auth expiry.

import { API_BASE } from './apiConfig';
import { authHeaders, isSignedIn } from './auth';

let _tier = 'free';

export function currentTier() {
  return _tier;
}

function emit() {
  try {
    window.dispatchEvent(new CustomEvent('wtr-tier-changed', { detail: { tier: _tier } }));
  } catch (e) { /* never let an event break the app */ }
}

export async function refreshTier() {
  if (!isSignedIn()) {
    _tier = 'free';
    emit();
    return _tier;
  }
  try {
    const r = await fetch(`${API_BASE}/api/wtr/me/entitlements`, {
      headers: authHeaders({ Accept: 'application/json' }),
    });
    let d = {};
    try { d = await r.json(); } catch (e) {}
    _tier = r.ok && d && d.ok && d.tier === 'plus' ? 'plus' : 'free';
  } catch (e) {
    _tier = 'free';
  }
  emit();
  return _tier;
}
